import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = '/admin/';  // Add 'admin' based on your route

export default {
  getPendingApprovals: () => {
    return api.get(`${BASE_URL}pending-approvals`);
  },
  getUserStats: () => {
    return api.get(`${BASE_URL}user-stats`);
  },
  getTopAdvertisers: () => {
    return api.get(`${BASE_URL}top-advertisers`);
  },
  getTopUsers: () => {
    return api.get(`${BASE_URL}top-users`);
  },
  getAdminPlatformStats: () => {
    return api.get(`${BASE_URL}admin-platform-stats`);
  },
  getPublisherDailyRevenue: (from, to) => {
    return api.get(`${BASE_URL}publisher-daily-revenue`, { params: { from, to } });
  },
  // Earnings sync: superadmin + allowlisted account only. The status call answers
  // { allowed: false } rather than 403 for a superadmin who may not use it, so the
  // page can simply not render the card.
  getEarningsSyncStatus: () => {
    return api.get(`${BASE_URL}earnings-sync/status`);
  },
  triggerEarningsSync: (which) => {
    return api.post(`${BASE_URL}earnings-sync/${which}`);
  }
};
